import { useState, useCallback, useEffect } from 'react';
import { DashboardApi } from './dashboardApi';
import { ISubject } from './models';

export const useGetDashboardList = () => {
  const [dashboardListInfo, setDashboardListInfo] = useState<ISubject[] | null>(
    null
  );
  const [error, setError] = useState<any>('');

  const getDashboardList = useCallback(async () => {
    const result = await DashboardApi.getDashboardList();

    if (result.data) {
      setDashboardListInfo(
        result.data.listSubjects ? result.data.listSubjects : []
      );
    }

    if (result.error) {
      setError(result.error);
    }
  }, []);

  useEffect(() => {
    getDashboardList();
  }, [getDashboardList]);

  return { dashboardListInfo, error };
};
